import { CartFieldsFragment } from 'types/graphql'
import { assertExists } from 'utils/assert'
import { fractionize } from 'utils/currencyTransforms'

export const mapCartProductsToTrackingParams = (cart: CartFieldsFragment) => {
  return cart.bags.flatMap((bag) =>
    bag.skus.map((sku) => {
      assertExists(sku.productVariant)
      return {
        product_id: sku.productVariant.product.id,
        sku: sku.sku_id,
        name: sku.name,
        variant: sku.productVariant.name,
        brand: sku.brand,
        price: fractionize(sku.line_price),
        quantity: sku.quantity,
        currency: cart.currency,
        image_url: sku.thumbnail
      }
    })
  )
}
